import { Utility, utility_controller } from '../utility/utility_controller'
import { playerInstances } from '../vimeo/vimeo_init_sdk_players'
import history_controller from '../history/history_controller_new'
import page_overlay_close_controller from './page_overlay_close_controller'
import { attachHlsIfNeeded } from '../html5video/hls_loader'

// Hook the WP edit button (#lay-frontend-edit-button) to point at the
// page-overlay's post while the overlay is open. Restore on close so the
// button goes back to editing the underlying page. Only one page overlay
// can be open at a time, so a single restore-snapshot is enough.
;(function () {
	if (typeof window === 'undefined' || !window.laytheme || typeof window.laytheme.on !== 'function') return
	window.laytheme.on('overlayshown', function ($overlayEl) {
		var overlay = $overlayEl && $overlayEl[0] ? $overlayEl[0] : null
		if (!overlay) return
		var id = overlay.getAttribute('data-id')
		var type = overlay.getAttribute('data-type') || 'page'
		if (!id) return
		history_controller.updateEditButtonUrl(type, id)
	})
	window.laytheme.on('overlayhidden', function () {
		jQuery('body').removeClass('do-page-overlay-content-transition')
		// Restore the edit button to the underlying page. `getState()` returns
		// the current history entry — the page that was active before the
		// overlay opened (overlays don't pushState).
		var st = history_controller.getState()
		if (st && st.type && st.id) {
			history_controller.updateEditButtonUrl(st.type, st.id)
			return
		}
		// Fallback if no history state yet (e.g. first page load): use body's
		// data-type / data-id which the theme sets server-side.
		var bodyType = document.body && document.body.getAttribute('data-type')
		var bodyId = document.body && document.body.getAttribute('data-id')
		if (bodyType && bodyId) {
			history_controller.updateEditButtonUrl(bodyType, bodyId)
		}
	})
})()

// Toggle body classes controlled by the active page overlay. Tracks
// `display-block-overlay` (not `lay-show-overlay`) so classes cover both the
// in animation and the out animation.
function syncPageOverlayBodyClasses() {
	var $displayBlockOverlays = jQuery('.lay-overlay.display-block-overlay')
	var $body = jQuery('body')

	$body.toggleClass('lay-keep-sitetitle-above-overlay', $displayBlockOverlays.filter('[data-keep-sitetitle-above="on"]').length > 0)
	$body.toggleClass('lay-page-overlay-hide-sitetitle', $displayBlockOverlays.filter('[data-hide-site-title="on"]').length > 0)
	$body.toggleClass('lay-page-overlay-hide-menu', $displayBlockOverlays.filter('[data-hide-menu="on"]').length > 0)
	$body.toggleClass('lay-page-overlay-hide-menu-2', $displayBlockOverlays.filter('[data-hide-menu-2="on"]').length > 0)
	$body.toggleClass('lay-page-overlay-hide-menu-3', $displayBlockOverlays.filter('[data-hide-menu-3="on"]').length > 0)
	$body.toggleClass('lay-page-overlay-hide-menu-4', $displayBlockOverlays.filter('[data-hide-menu-4="on"]').length > 0)
}

function clearBurgerCloseStates() {
	jQuery('.overlay-burger[data-lay-burger-turns-to-close="1"]').removeClass('lay-overlay-burger-is-close')
}

function setBurgerCloseStateForOverlay($overlay, isActive) {
	if (!$overlay || !$overlay.length) return
	var id = $overlay.attr('data-id')
	if (!id) return
	jQuery('.overlay-burger[data-lay-burger-turns-to-close="1"][data-id="' + id + '"]').toggleClass('lay-overlay-burger-is-close', !!isActive)
}

function markPageOverlayContentTransition() {
	if (layData.use_revealing_transition_when_opening_page_overlay == 'on') {
		jQuery('body').addClass('do-page-overlay-content-transition')
	}
}

function getPageOverlayCloseAnimation(overlayEl) {
	var closeAnimations = ['fade', 'slide-from-top', 'slide-from-left', 'slide-from-right', 'slide-from-bottom']
	var prefix = Utility.isPhoneSize ? 'lay-phone-close-' : 'lay-close-'

	for (var i = 0; i < closeAnimations.length; i++) {
		if (overlayEl.classList.contains(prefix + closeAnimations[i])) {
			return closeAnimations[i]
		}
	}

	return 'same'
}

function getPageOverlayCloseBranch(overlayEl) {
	var closeAnimation = getPageOverlayCloseAnimation(overlayEl)
	if (closeAnimation === 'fade') {
		return 'fade'
	}
	if (closeAnimation.indexOf('slide-from-') === 0) {
		return 'slide'
	}

	if ((overlayEl.classList.contains('lay-fade') && (Utility.isDesktopSize || Utility.isTabletSize)) || (overlayEl.classList.contains('lay-phone-fade') && Utility.isPhoneSize)) {
		return 'fade'
	}
	if ((overlayEl.classList.contains('lay-none') && (Utility.isDesktopSize || Utility.isTabletSize)) || (overlayEl.classList.contains('lay-phone-none') && Utility.isPhoneSize)) {
		return 'none'
	}
	return 'slide'
}

function startPageOverlaySlideClose(overlayEl) {
	window.requestAnimationFrame(function () {
		window.requestAnimationFrame(function () {
			jQuery(overlayEl).removeClass('lay-show-overlay')
		})
	})
}

// Function to normalize URL by removing language prefixes (e.g., /de/, /en/)
var normalizeURLForComparison = function (url) {
	if (!url) return url

	try {
		var urlObj = new URL(url)
		var path = urlObj.pathname

		// Remove language prefix pattern: /{2-3 letter code}/ at the start of path
		// This matches common language codes like /de/, /en/, /fr/, /es/, etc.
		path = path.replace(/^\/[a-z]{2,3}\//i, '/')

		// Reconstruct URL with normalized path
		urlObj.pathname = path
		return urlObj.toString()
	} catch (e) {
		// If URL parsing fails, try simple string replacement
		// Remove language prefix pattern from path
		return url.replace(/(https?:\/\/[^\/]+)\/[a-z]{2,3}\//i, '$1/')
	}
}

var showHideAllOverlays = function (href) {
	jQuery('body').addClass('do-page-overlay-transition')

	var rVal = false
	var fixBody = false
	var $targetOverlay = null
	var matchedLink = null // Store the actual link (with language prefix) when match is found
	var originalHref = href

	jQuery('.lay-overlay').each(function () {
		// make sure we match the protocol of the link, otherwise page overlays may not open!

		// find a page overlay
		var $randomOverlay = jQuery(this)
		var link = $randomOverlay.attr('data-link')
		// does link use https or http?
		var linkProtocol = link.split('://')[0]
		var hrefProtocol = originalHref.split('://')[0]
		// now change href so it is the same protocol as the link
		var hrefWithMatchingProtocol = originalHref.replace(hrefProtocol, linkProtocol)

		// Normalize both URLs for comparison (removes language prefixes like /de/, /en/)
		var normalizedLink = normalizeURLForComparison(link)
		var normalizedHref = normalizeURLForComparison(hrefWithMatchingProtocol)

		// Compare both normalized URLs and original URLs (for backwards compatibility)
		if (normalizedHref == normalizedLink || hrefWithMatchingProtocol == link) {
			rVal = true
			$targetOverlay = $randomOverlay
			matchedLink = link // Store the actual link with language prefix
			href = hrefWithMatchingProtocol // Update href for menu activation
		}
	})

	// Check if the overlay is already open - if so, close it instead (toggle behavior)
	if (rVal && $targetOverlay && $targetOverlay.hasClass('lay-show-overlay')) {
		hideAllOverlays()
		return rVal
	}

	hideAllOverlays(href)
	if (rVal) {
		// Use the actual matched link (with language prefix) for finding the overlay
		var overlayLink = matchedLink || href

		// activate menupoint
		var $menuItem = jQuery('a[href="' + href + '"]').closest('.menu-item')
		$menuItem.addClass('current-menu-item')

		// Fix body only when the per-overlay "Lock page scroll while overlay is
		// open" setting is on. When smooth scroll is enabled and the lock is
		// off, smooth_scroll_controller's bodyPreventFunction routes wheel
		// events outside the overlay to the page Lenis instead — the body
		// stays scrollable underneath, as the checkbox label promises.
		var $overlay = jQuery('.lay-overlay[data-link="' + overlayLink + '"]')
		var shouldFixBody = $overlay.attr('data-disable-scroll') == 'on'

		if (shouldFixBody) {
			fixBody = true
			// Use the unified body lock system (Lenis-compatible, uses fixBody internally)
			if (window.smooth_scroll_controller && typeof window.smooth_scroll_controller.addBodyLock === 'function') {
				window.smooth_scroll_controller.addBodyLock('page-overlay')
			} else {
				// Fallback to fixBody if smooth_scroll_controller not available
				utility_controller.fixBody(true)
			}
		}

		window.laytheme.emit('page_overlay_before_shown', jQuery('.lay-overlay[data-link="' + overlayLink + '"]'))
		window.laytheme.emit('page_overlay_open_start', jQuery('.lay-overlay[data-link="' + overlayLink + '"]'))
		// timeout so on safari the animation isnt janky after fixing body :)
		setTimeout(function () {
			// need to use .off and then .on there, instead of just .one, because child elements may trigger transitionend
			// like for example a .below, .in-view class and then this would only trigger once, and return in if (event.target != this) { for the wrong cause
			jQuery('.lay-overlay[data-link="' + overlayLink + '"]').off('transitionend animationend')
			jQuery('.lay-overlay[data-link="' + overlayLink + '"]').on('transitionend animationend', function (event) {
				// Only proceed if the event target is the overlay itself, not a child element
				if (event.target !== this) {
					return
				}

				// note to myself: layCarouselFadeCarousel.loadFirstLazyImage($target) only loads first image if its in viewport
				// thats why for overlays i need to call this once overlay has shown
				// FADE CAROUSEL:
				// if the carousel images are lazyload and fade, the fadeCarousel's following function will handle this:
				if (typeof window.layCarouselFadeCarousel != 'undefined' && typeof window.layCarouselFadeCarousel.loadFirstLazyImage != 'undefined') {
					window.layCarouselFadeCarousel.loadFirstLazyImage(jQuery(this))
				}
				if (typeof window.layCarouselScrollCarousel != 'undefined' && typeof window.layCarouselScrollCarousel.loadFirstLazyImage != 'undefined') {
					window.layCarouselScrollCarousel.loadFirstLazyImage(jQuery(this))
				}
				if (typeof window.layCarouselSwiper != 'undefined' && typeof window.layCarouselSwiper.loadFirstLazyImage != 'undefined') {
					window.layCarouselSwiper.loadFirstLazyImage(jQuery(this))
				}
				// Play background videos when overlay animation completes
				playBackgroundVideosInOverlay(jQuery(this))
				jQuery('body').removeClass('do-page-overlay-transition')
				markPageOverlayContentTransition()

				// this triggers setting correct classes for element_animate_in_on_scroll_for_pageoverlays.js:
				window.laytheme.emit('overlayshown_animation_ended', jQuery('.lay-overlay[data-link="' + overlayLink + '"]'))
				window.laytheme.emit('page_overlay_open_end', jQuery('.lay-overlay[data-link="' + overlayLink + '"]'))
				// only add this class after 'overlayshown_animation_ended' was triggered! otherwise pageoverlay element animate in on scroll is not binded
				jQuery('.lay-overlay[data-link="' + overlayLink + '"]').addClass('lay-overlay-was-opened-at-least-once')
			})
			// todo: lazyload swiper carousel first image

			jQuery('.lay-overlay[data-link="' + overlayLink + '"]').addClass('display-block-overlay')
			setBurgerCloseStateForOverlay(jQuery('.lay-overlay[data-link="' + overlayLink + '"]'), true)
			syncPageOverlayBodyClasses()

			window.laytheme.emit('page_overlay_display_block', jQuery('.lay-overlay[data-link="' + overlayLink + '"]'))
			setTimeout(function () {
				jQuery('.lay-overlay[data-link="' + overlayLink + '"]').addClass('lay-show-overlay')
				jQuery('.lay-overlay-bg[data-link="' + overlayLink + '"]').addClass('lay-show-overlay-bg')

				window.laytheme.emit('overlayshown', jQuery('.lay-overlay[data-link="' + overlayLink + '"]'))

				jQuery('body').addClass('lay-overlay-open')
				// transitionend animationend above wont be triggered if animation is none. so we emit overlayshown_animation_ended here, and call the carousel functions here
				var noneDesktopClasses = ['lay-none', 'lay-none-top', 'lay-none-left', 'lay-none-right', 'lay-none-bottom']
				var nonePhoneClasses = ['lay-phone-none', 'lay-phone-none-top', 'lay-phone-none-left', 'lay-phone-none-right', 'lay-phone-none-bottom']

				var animationIsNone = false
				if (Utility.isDesktopSize || Utility.isTabletSize) {
					animationIsNone = noneDesktopClasses.some(function (cls) {
						return jQuery('.lay-overlay[data-link="' + overlayLink + '"]').hasClass(cls)
					})
				} else if (Utility.isPhoneSize) {
					animationIsNone = nonePhoneClasses.some(function (cls) {
						return jQuery('.lay-overlay[data-link="' + overlayLink + '"]').hasClass(cls)
					})
				}

				if (animationIsNone) {
					markPageOverlayContentTransition()
					// this triggers setting correct classes for element_animate_in_on_scroll_for_pageoverlays.js:
					window.laytheme.emit('overlayshown_animation_ended', jQuery('.lay-overlay[data-link="' + overlayLink + '"]'))
					window.laytheme.emit('page_overlay_open_end', jQuery('.lay-overlay[data-link="' + overlayLink + '"]'))
					// only add this class after 'overlayshown_animation_ended' was triggered! otherwise pageoverlay element animate in on scroll is not binded
					jQuery('.lay-overlay[data-link="' + overlayLink + '"]').addClass('lay-overlay-was-opened-at-least-once')
				}

				if (compatibilityMode || animationIsNone) {
					setTimeout(function () {
						var $target = jQuery('.lay-overlay[data-link="' + overlayLink + '"]')
						// FADE CAROUSEL:
						if (typeof window.layCarouselFadeCarousel != 'undefined' && typeof window.layCarouselFadeCarousel.loadFirstLazyImage != 'undefined') {
							window.layCarouselFadeCarousel.loadFirstLazyImage($target)
						}
						// SCROLL CAROUSEL:
						if (typeof window.layCarouselScrollCarousel != 'undefined' && typeof window.layCarouselScrollCarousel.loadFirstLazyImage != 'undefined') {
							window.layCarouselScrollCarousel.loadFirstLazyImage($target)
						}
						// swiper carousel
						if (typeof window.layCarouselSwiper != 'undefined' && typeof window.layCarouselSwiper.loadFirstLazyImage != 'undefined') {
							window.layCarouselSwiper.loadFirstLazyImage($target)
						}
						// Play background videos when overlay is shown (for compatibility mode or none animation)
						playBackgroundVideosInOverlay($target)
					}, 0)
				} else {
					// For normal animations, also play background videos when overlay becomes visible
					// This ensures videos play even if transitionend/animationend doesn't fire properly
					setTimeout(function () {
						var $target = jQuery('.lay-overlay[data-link="' + overlayLink + '"]')
						playBackgroundVideosInOverlay($target)
					}, 100)
				}
			}, 50)
		}, 0)
	}
	return rVal
}

var bindClicks = function () {
	jQuery(document).on('click', '.lay-overlay-bg', function () {
		if (jQuery(this).attr('data-close-on-background-click') === 'off') {
			return
		}
		hideAllOverlays()
	})
	jQuery(document).on('click', '.overlay-close', function () {
		hideAllOverlays()
	})
	jQuery(document).on('click', '.user-overlay-close', function () {
		hideAllOverlays()
	})
}

var onKeyDown = function (e) {
	switch (e.which) {
		case 27: // esc
			if (
				jQuery('.lay-overlay.lay-show-overlay').filter(function () {
					return jQuery(this).attr('data-close-on-esc') !== 'off'
				}).length === 0
			) {
				return
			}
			// Remove body lock if using new system (uses unfixBody internally)
			if (window.smooth_scroll_controller && typeof window.smooth_scroll_controller.removeBodyLock === 'function') {
				window.smooth_scroll_controller.removeBodyLock('page-overlay')
			} else {
				utility_controller.unfixBody()
			}
			// timeout so on safari the animation isnt janky :)
			setTimeout(function () {
				hideAllOverlays()
			}, 0)
			break
	}
}

var hideAllOverlays = function (exceptThisOne) {
	jQuery('body').addClass('do-page-overlay-transition')
	jQuery('body').removeClass('do-page-overlay-content-transition')
	clearBurgerCloseStates()
	// Only remove body lock if:
	// 1. We're closing all overlays (exceptThisOne is undefined/null), OR
	// 2. The overlay staying open (exceptThisOne) doesn't have data-disable-scroll='on'
	var $stayingOverlay = exceptThisOne ? jQuery('.lay-overlay[data-link="' + exceptThisOne + '"]') : null
	var stayingOverlayNeedsLock = $stayingOverlay && $stayingOverlay.length > 0 && $stayingOverlay.attr('data-disable-scroll') == 'on'
	var shouldKeepLock = exceptThisOne && stayingOverlayNeedsLock

	if (!shouldKeepLock) {
		// Remove body lock if using new system (uses unfixBody internally)
		if (window.smooth_scroll_controller && typeof window.smooth_scroll_controller.removeBodyLock === 'function') {
			window.smooth_scroll_controller.removeBodyLock('page-overlay')
		} else {
			utility_controller.unfixBody()
		}
	}
	// timeout so on safari the animation isnt janky :)
	setTimeout(function () {
		if (exceptThisOne) {
			jQuery('.lay-overlay.lay-show-overlay').each(function () {
				if (jQuery(this).attr('data-link') != exceptThisOne) {
					var $overlay = jQuery(this)
					var hrefL = utility_controller.filterURL($overlay.attr('data-link'))
					// remove link active state
					var $menuItem = jQuery('a[href="' + hrefL + '"]').closest('.menu-item')
					$menuItem.removeClass('current-menu-item')

					// Pause videos in the overlay that's being closed
					pauseYouTubeVimeoVideosAndNormalVideos($overlay)
					this.classList.add('lay-overlay-closing')
					window.laytheme.emit('page_overlay_close_start', $overlay)
					var closeBranch = getPageOverlayCloseBranch(this)

					if (closeBranch === 'fade') {
						// this is just for animation fade
						jQuery(this).off('animationend')
						jQuery(this).on('animationend', function (event) {
							// Only proceed if the event target is the element itself, not a child element
							if (event.target !== this) {
								return
							}
							this.classList.remove('lay-fadeout')
							this.classList.remove('lay-overlay-closing')
							this.classList.remove('lay-show-overlay')
							jQuery(this).removeClass('display-block-overlay')
							syncPageOverlayBodyClasses()
							jQuery(this).find('.lay-content')[0].scrollTop = 0
							jQuery('body').removeClass('do-page-overlay-transition')
							// if we use exceptThisOne, we just go from one overlay to another, so we dont emit overlayhidden. cause doing so woudl cause lightbox addon to think ok all overlays are closed, lets use lightbox of page that was underneath overlay
							// window.laytheme.emit('overlayhidden')
							window.laytheme.emit('page_overlay_close_end', jQuery(this))
						})
						this.classList.add('lay-fadeout')
					} else if (closeBranch === 'none') {
						// this is just for animation none
						jQuery(this).find('.lay-content')[0].scrollTop = 0
						jQuery(this).removeClass('lay-show-overlay')
						jQuery(this).removeClass('display-block-overlay')
						this.classList.remove('lay-overlay-closing')
						syncPageOverlayBodyClasses()
						jQuery('body').removeClass('do-page-overlay-transition')
						// if we use exceptThisOne, we just go from one overlay to another, so we dont emit overlayhidden. cause doing so woudl cause lightbox addon to think ok all overlays are closed, lets use lightbox of page that was underneath overlay
						// window.laytheme.emit('overlayhidden')
						window.laytheme.emit('page_overlay_close_end', jQuery(this))
					} else {
						// this is just for normal slide animation
						jQuery(this).off('transitionend')
						jQuery(this).on('transitionend', function (event) {
							// Only proceed if the event target is the element itself, not a child element
							if (event.target !== this) {
								return
							}
							jQuery(this).find('.lay-content')[0].scrollTop = 0
							jQuery(this).removeClass('display-block-overlay')
							this.classList.remove('lay-overlay-closing')
							syncPageOverlayBodyClasses()
							jQuery('body').removeClass('do-page-overlay-transition')
							// if we use exceptThisOne, we just go from one overlay to another, so we dont emit overlayhidden. cause doing so would cause lightbox addon to think ok all overlays are closed, lets use lightbox of page that was underneath overlay
							// window.laytheme.emit('overlayhidden')
							window.laytheme.emit('page_overlay_close_end', jQuery(this))
						})
						startPageOverlaySlideClose(this)
					}

					if (compatibilityMode) {
						jQuery(this).find('.lay-content')[0].scrollTop = 0
						this.classList.remove('lay-overlay-closing')
						jQuery('body').removeClass('do-page-overlay-transition')
					}
				}
			})
			jQuery('.lay-overlay-bg.lay-show-overlay-bg').each(function () {
				if (jQuery(this).attr('data-link') != exceptThisOne) {
					jQuery(this).removeClass('lay-show-overlay-bg')
				}
			})
			// an overlay is still open?
			if (jQuery('.lay-overlay.lay-show-overlay').length > 0) {
				jQuery('.lay-overlay-bg').removeClass('lay-show-overlay-bg')
				jQuery('body').removeClass('lay-overlay-open')

				// if we use exceptThisOne, we just go from one overlay to another, so we dont emit overlayhidden. cause doing so would cause lightbox addon to think ok all overlays are closed, lets use lightbox of page that was underneath overlay
				// window.laytheme.emit('overlayhidden')
			}
		} else {
			jQuery('.lay-overlay.lay-show-overlay').each(function () {
				var $overlay = jQuery(this)
				var hrefL = utility_controller.filterURL($overlay.attr('data-link'))
				// remove link active state
				var $menuItem = jQuery('a[href="' + hrefL + '"]').closest('.menu-item')
				$menuItem.removeClass('current-menu-item')

				// Pause videos in the overlay that's being closed
				pauseYouTubeVimeoVideosAndNormalVideos($overlay)
				this.classList.add('lay-overlay-closing')
				window.laytheme.emit('page_overlay_close_start', $overlay)
				var closeBranch = getPageOverlayCloseBranch(this)

				if (closeBranch === 'fade') {
					// this is just for animation fade
					jQuery(this).off('animationend')
					jQuery(this).on('animationend', function (event) {
						// Only proceed if the event target is the element itself, not a child element
						if (event.target !== this) {
							return
						}
						this.classList.remove('lay-fadeout')
						this.classList.remove('lay-overlay-closing')
						this.classList.remove('lay-show-overlay')
						jQuery(this).removeClass('display-block-overlay')
						syncPageOverlayBodyClasses()
						jQuery(this).find('.lay-content')[0].scrollTop = 0
						jQuery('body').removeClass('do-page-overlay-transition')
						window.laytheme.emit('overlayhidden', jQuery(this))
						window.laytheme.emit('page_overlay_close_end', jQuery(this))
					})
					this.classList.add('lay-fadeout')
				} else if (closeBranch === 'none') {
					// this is just for animation none
					jQuery(this).find('.lay-content')[0].scrollTop = 0
					jQuery(this).removeClass('lay-show-overlay')
					jQuery(this).removeClass('display-block-overlay')
					this.classList.remove('lay-overlay-closing')
					syncPageOverlayBodyClasses()
					jQuery('body').removeClass('do-page-overlay-transition')
					window.laytheme.emit('overlayhidden', jQuery(this))
					window.laytheme.emit('page_overlay_close_end', jQuery(this))
				} else {
					// this is just for normal slide animation
					jQuery(this).off('transitionend')
					jQuery(this).on('transitionend', function (event) {
						// Only proceed if the event target is the element itself, not a child element
						if (event.target !== this) {
							return
						}
						jQuery(this).find('.lay-content')[0].scrollTop = 0
						jQuery(this).removeClass('display-block-overlay')
						this.classList.remove('lay-overlay-closing')
						syncPageOverlayBodyClasses()
						jQuery('body').removeClass('do-page-overlay-transition')
						window.laytheme.emit('overlayhidden', jQuery(this))
						window.laytheme.emit('page_overlay_close_end', jQuery(this))
					})
					startPageOverlaySlideClose(this)
				}
				if (compatibilityMode) {
					jQuery(this).find('.lay-content')[0].scrollTop = 0
					jQuery(this).removeClass('display-block-overlay')
					this.classList.remove('lay-overlay-closing')
					syncPageOverlayBodyClasses()
					jQuery('body').removeClass('do-page-overlay-transition')
				}
			})
			jQuery('.lay-overlay-bg').removeClass('lay-show-overlay-bg')
			jQuery('body').removeClass('lay-overlay-open')
		}
		// Also pause videos in any overlays that are not currently shown (as a safety measure)
		setTimeout(function () {
			jQuery('.lay-overlay:not(.lay-show-overlay)').each(function () {
				pauseYouTubeVimeoVideosAndNormalVideos(jQuery(this))
			})
		}, 0)
	}, 0)
}

// pause all youtube and vimeo videos that are not currently shown in overlay
// but exclude background videos (they should autoplay)
var pauseYouTubeVimeoVideosAndNormalVideos = function ($myOverlayWithVideos) {
	if (typeof $myOverlayWithVideos != 'undefined' && $myOverlayWithVideos.length > 0) {
		// Pause Vimeo videos - use existing player instance if available
		$myOverlayWithVideos.find("iframe[src*='player.vimeo.com/']").each(function () {
			if (typeof Vimeo != 'undefined') {
				// Try to get existing player instance from the Map
				var player = playerInstances.get(this)
				if (player) {
					// Use existing player instance
					player.pause().catch(function (error) {
						// If pause fails, try creating a new player instance as fallback
						try {
							var fallbackPlayer = new Vimeo.Player(this)
							fallbackPlayer.pause()
						} catch (e) {
							// Silently fail if player can't be created
						}
					})
				} else {
					// No existing instance, create a new one
					try {
						var newPlayer = new Vimeo.Player(this)
						newPlayer.pause()
					} catch (e) {
						// Silently fail if player can't be created
					}
				}
			}
		})

		// Pause YouTube videos
		$myOverlayWithVideos.find("iframe[src*='youtube.com'], iframe[src*='youtu.be']").each(function () {
			var player = jQuery(this).data('ytplayer')
			if (typeof player == 'undefined' && window.youtubeApiReady) {
				player = new YT.Player(this, {
					events: {
						onReady: function (event) {
							event.target.stopVideo()
						},
					},
				})
				jQuery(this).data('ytplayer', player)
			} else if (typeof player != 'undefined' && typeof player.stopVideo == 'function') {
				player.stopVideo()
			}
		})

		// Pause all HTML5 videos except background videos (which should autoplay)
		$myOverlayWithVideos.find('video:not(.lay-background-video):not(.lay-background-video-desktop):not(.lay-background-video-mobile)').each(function () {
			this.pause()
		})
	}
}

// Play background videos in the opened overlay
var playBackgroundVideosInOverlay = function ($overlay) {
	if (typeof $overlay == 'undefined' || $overlay.length === 0) {
		return
	}

	// Get the current screen size
	var screenSize = Utility.screenSize

	// Play desktop/tablet background videos
	if (screenSize === 'desktop' || screenSize === 'tablet') {
		$overlay.find('.lay-background-video-desktop, .lay-background-video').each(function () {
			var video = this
			// If video has data-src attribute, set src first
			if (jQuery(video).attr('src') === undefined && jQuery(video).attr('data-src') !== undefined) {
				var video_url = jQuery(video).attr('data-src')
				jQuery(video).attr('src', video_url)
			}
			attachHlsIfNeeded(video)
			// Play the video
			if (video.readyState >= 2) {
				// Video can play
				video.play().catch(function (error) {})
			} else {
				// Wait for video to be ready
				jQuery(video).one('loadeddata', function () {
					video.play().catch(function (error) {})
				})
			}
		})
	}

	// Play mobile background videos
	if (screenSize === 'phone') {
		$overlay.find('.lay-background-video-mobile, .lay-background-video').each(function () {
			var video = this
			// If video has data-src attribute, set src first
			if (jQuery(video).attr('src') === undefined && jQuery(video).attr('data-src') !== undefined) {
				var video_url = jQuery(video).attr('data-src')
				jQuery(video).attr('src', video_url)
			}
			attachHlsIfNeeded(video)
			// Play the video
			if (video.readyState >= 2) {
				// Video can play
				video.play().catch(function (error) {})
			} else {
				// Wait for video to be ready
				jQuery(video).one('loadeddata', function () {
					video.play().catch(function (error) {})
				})
			}
		})
	}
}

var bindKeys = function () {
	document.addEventListener('keydown', onKeyDown)
}

var bindActivateLinksInOverlay = function () {
	window.laytheme.on('newpageshown', function () {
		activateCurrentLink()
	})
}

// this is for links inside of a page overlay, when you use a page overlay as a burger menu for example
var activateCurrentLink = function () {
	jQuery('.lay-overlay a').removeClass('current-link')

	var id = jQuery('body').attr('data-id')
	var type = jQuery('body').attr('data-type')
	var $anchor = jQuery('.lay-overlay a[data-id="' + id + '"][data-type="' + type + '"]')
	if ($anchor.length != 0) {
		$anchor.each(function () {
			this.classList.add('current-link')
		})
	}

	// On a project, also mark category anchors and "projects overview" pages —
	// mirrors the main-nav behavior in activate_menupoints.js so the "Style
	// Active Links in Overlay" feature highlights the same things the menu does.
	if (type === 'project') {
		var catids = utility_controller.parseIdsString(jQuery('body').attr('data-catid'))
		if (!Array.isArray(catids)) {
			catids = [catids]
		}
		for (var i = 0; i < catids.length; i++) {
			var catid = catids[i]
			var $catAnchor = jQuery('.lay-overlay a[data-catid="' + catid + '"][data-type="category"]')
			if ($catAnchor.length != 0) {
				$catAnchor.each(function () {
					this.classList.add('current-link')
				})
			}
		}

		// Pages opted in via "Yes, underline this page's menu point when we are
		// in a project" — `nav_menu_css_class` adds `.lay-projects-overview` to
		// the <li>, so target the <a> inside it.
		jQuery('.lay-overlay .lay-projects-overview a').addClass('current-link')
	}
}

var compatibilityMode = false
var turnOnCompatibilityModeMaybe = function () {
	var ua = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase()
	var isInstagram = ua.indexOf('instagram') > -1 ? true : false

	if ((Utility.browserName == 'Safari' && Utility.browserVersion < 13) || isInstagram) {
		compatibilityMode = true
		jQuery('.lay-overlay').each(function () {
			if (jQuery(this).hasClass('lay-fade')) {
				jQuery(this).removeClass('lay-fade')
				jQuery(this).addClass('lay-none')
			}
			if (jQuery(this).hasClass('lay-phone-fade')) {
				jQuery(this).removeClass('lay-phone-fade')
				jQuery(this).addClass('lay-phone-none')
			}
			if (jQuery(this).hasClass('lay-slide-from-top')) {
				jQuery(this).removeClass('lay-slide-from-top')
				jQuery(this).addClass('lay-none-top')
			}
			if (jQuery(this).hasClass('lay-phone-slide-from-top')) {
				jQuery(this).removeClass('lay-phone-slide-from-top')
				jQuery(this).addClass('lay-phone-none-top')
			}
			if (jQuery(this).hasClass('lay-slide-from-left')) {
				jQuery(this).removeClass('lay-slide-from-left')
				jQuery(this).addClass('lay-none-left')
			}
			if (jQuery(this).hasClass('lay-phone-slide-from-left')) {
				jQuery(this).removeClass('lay-phone-slide-from-left')
				jQuery(this).addClass('lay-phone-none-left')
			}
			if (jQuery(this).hasClass('lay-slide-from-right')) {
				jQuery(this).removeClass('lay-slide-from-right')
				jQuery(this).addClass('lay-none-right')
			}
			if (jQuery(this).hasClass('lay-phone-slide-from-right')) {
				jQuery(this).removeClass('lay-phone-slide-from-right')
				jQuery(this).addClass('lay-phone-none-right')
			}
			if (jQuery(this).hasClass('lay-slide-from-bottom')) {
				jQuery(this).removeClass('lay-slide-from-bottom')
				jQuery(this).addClass('lay-none-bottom')
			}
			if (jQuery(this).hasClass('lay-phone-slide-from-bottom')) {
				jQuery(this).removeClass('lay-phone-slide-from-bottom')
				jQuery(this).addClass('lay-phone-none-bottom')
			}
		})
	}
}

var bindEvents = function () {
	window.laytheme.on('overlayhidden', function () {
		if (jQuery.fn.fullpage != undefined && jQuery.fn.fullpage.setAllowScrolling != undefined) {
			jQuery.fn.fullpage.setAllowScrolling(true)
		}
		page_overlay_close_controller.clearRevealTimers()
		page_overlay_close_controller.hide()
	})
	window.laytheme.on('overlayshown', function () {
		if (jQuery.fn.fullpage != undefined && jQuery.fn.fullpage.setAllowScrolling != undefined) {
			jQuery.fn.fullpage.setAllowScrolling(false)
		}
	})
	window.laytheme.on('page_overlay_display_block', function ($overlay) {
		page_overlay_close_controller.scheduleReveal($overlay)
		page_overlay_close_controller.syncOutsideForDuration($overlay)
	})
	window.laytheme.on('overlayshown', function ($overlay) {
		page_overlay_close_controller.syncOutsideForDuration($overlay)
	})
	window.laytheme.on('overlayshown_animation_ended', function ($overlay) {
		page_overlay_close_controller.syncOutside($overlay)
		page_overlay_close_controller.revealAfterAnimation($overlay)
	})
	window.laytheme.on('page_overlay_open_end', function ($overlay) {
		page_overlay_close_controller.revealAfterAnimation($overlay)
	})
	window.laytheme.on('page_overlay_close_start', function ($overlay) {
		page_overlay_close_controller.clearRevealTimers($overlay)
		page_overlay_close_controller.hide($overlay)
	})
	window.laytheme.on('page_overlay_close_end', function ($overlay) {
		page_overlay_close_controller.hide($overlay)
	})
	page_overlay_close_controller.bindResizeSync()

	if (typeof MutationObserver != 'undefined') {
		var observer = new MutationObserver(function (mutationsList) {
			// fontdue plugin fullscreen slider compatibility :)

			for (i = 0; i < mutationsList.length; i++) {
				var entry = mutationsList[i]
				if (entry.attributeName == 'data-fontdue-store-modal') {
					if (entry.target.getAttribute('data-fontdue-store-modal') == 'open') {
						if (jQuery.fn.fullpage != undefined && jQuery.fn.fullpage.setAllowScrolling != undefined) {
							try {
								jQuery.fn.fullpage.setAllowScrolling(false)
							} catch (e) {}
						}
					} else if (entry.target.getAttribute('data-fontdue-store-modal') == 'closed') {
						if (jQuery.fn.fullpage != undefined && jQuery.fn.fullpage.setAllowScrolling != undefined) {
							try {
								jQuery.fn.fullpage.setAllowScrolling(true)
							} catch (e) {}
						}
					}
				}
			}
		})
		observer.observe(document.body, { attributes: true })
	}
}

var initPreopenOverlays = function () {
	jQuery('.lay-overlay.lay-preopen-overlay').each(function () {
		showHideAllOverlays(jQuery(this).attr('data-link'))
	})
}

var initOverlayModule = function () {
	window.laytheme.on('newpageshown', function () {
		turnOnCompatibilityModeMaybe()
	})
	window.laytheme.on('page_overlay_markup_ready', function () {
		turnOnCompatibilityModeMaybe()
		activateCurrentLink()
	})
	turnOnCompatibilityModeMaybe()
	bindClicks()
	bindKeys()
	bindActivateLinksInOverlay()
	bindEvents()
	initPreopenOverlays()
}

export { showHideAllOverlays, initOverlayModule, hideAllOverlays }
